<script>
import Layout from '@components/layout/company/main-visitant'
import { authMethods, authComputed } from '@state/helpers'
import defaults from '@/src/router/defaults'
import firebase from 'firebase/app'
const appConfig = require('@src/config').config;

export default {
  page: {
    title: 'Log in',
    meta: [
      {name: 'description', content: `Log in to ${appConfig.title}`}
    ],
  },
  components: { Layout },
  data() {
    return {
      email: '',
      fakeMail: '',
      password: '',
      updateError: null,
      tryingToLogIn: false,
      isReset: false,



      loading: false,
      disabled: false,
      emailAddress: this.$t('login.emailAddress'),
      passwordLogin: this.$t('form.password'),
      keepConnect: this.$t('login.keepConnect'),
      reset: this.$t('login.goReset'),
    }
  },
  computed: {
    ...authComputed,
  },
  watch: {
    loggedIn() {
      if (this.$store.getters['auth/loggedIn'] && !this.tryingToLogIn) {
        console.log('Redirecionar usuário logado')
        this.$router.push({ name: defaults.routeLogged[this.$store.getters['auth/loggedIn']] })
      }
    }
  },
  methods: {
    ...authMethods,
    async tryToLogIn() {
      this.updateError = null
      if(!this.password) {
        return;
      }

      if(!this.email || !this.password) {
        this.updateError = true
        return
      }
    //  this.fakeMail = await this.getAdminMailByFakeMail({email: this.email })
      this.fakeMail = 'ua_'+this.email.replace('@', '_')+'@adminusers.'+appConfig.emailKey;
      if(!this.fakeMail) {
        this.updateError = true
        return
      }

      this.tryingToLogIn = true
      try {
        await this.logIn({
          email: this.fakeMail,
          password: this.password,
        });
        this.$router.push(this.$route.query.redirectFrom || { name: defaults.routeLogged['ADMIN'] })
      } catch(error) {
        console.error( this.$t('login.error.loginTitle'), this.$t('login.providerCode.'+error.code));
        this.$swal({
          toast: true,
          position: 'top-end',
          type: 'error',
          title: this.$t('login.error.loginTitle'),
          text: this.$t('login.providerCode.'+error.code),
          showConfirmButton: false,
          timer: 20000
        });
        this.tryingToLogIn = false
        this.updateError = {message:this.$t('login.providerCode.'+error.code)}
      }
    },
    async tryReset() {
      if(!this.email) {
        this.updateError = true
        return
      }

      this.fakeMail = 'ua_'+this.email.replace('@', '_')+'@adminusers.'+appConfig.emailKey;
      this.tryingToLogIn = true
      try {
        let result = await firebase.functions().httpsCallable('auth-resetPassword')({email:this.fakeMail, workspace:'ADMIN'})
        console.log('result', result);
        if(result && result.data && result.data.status) {
          this.$swal({
            toast: true,
            position: 'top-end',
            type: 'success',
            title: this.$t('form.emailResetSuccess'),
            showConfirmButton: false,
            timer: 15000
          })
        }
        else {
          this.$swal({
            toast: true,
            position: 'top-end',
            type: 'error',
            title: this.$t('form.emailResetError'),
            showConfirmButton: false,
            timer: 20000
          })
        }
      } catch(error) {
        this.$swal({
          toast: true,
          position: 'top-end',
          type: 'error',
          title: this.$t('form.emailResetError'),
          showConfirmButton: false,
          timer: 20000
        })
      }
      this.tryingToLogIn = false
    },
    submitForm() {
      if(this.isReset) {
        this.tryReset()
      }
      else {
        this.tryToLogIn()
      }
    },
    async switchReset () {
      this.isReset = !this.isReset
    },
    async focusPassword () {
      this.$refs.password.$el.querySelector('input').focus();
    }
  },
}
</script>

<template>
  <Layout>
    <v-card
        :loading="loading"
        :class="[$style.card, 'mx-auto', 'my-12']"
    >
      <div class="logo">
        <img :src="require('@assets/images/sidebar-logo@3x.png')" alt="logo"/>
      </div>

      <v-card-title :class="$style.title" >{{ $t(isReset?'login.resetCompany':'navBar.logIn')}}</v-card-title>

      <v-form @submit.prevent="submitForm">
        <v-container>

          <v-text-field
              v-model="email"
              :label="emailAddress"
              solo
              :class="[$style.emailAddress, 'mx-auto']"
              autofocus
              @keyup.enter="focusPassword"
          >
          </v-text-field>
          <v-text-field
              v-if="!isReset"
              ref="password"
              v-model="password"
              :label="passwordLogin"
              type="password"
              solo
              :class="[$style.emailAddress, 'mx-auto']"
          ></v-text-field>
          <p v-if="updateError" :class="$style.error">
            {{updateError.message?updateError.message:$t('login.error.generic')}}
          </p>
<!--       <v-checkbox dark :class="[$style.check, 'mx-2']" v-model="disabled" :label="keepConnect"></v-checkbox>&ndash;&gt;-->
          <div class="my-2">
            <v-btn
                :class="$style.loginButton"
                type="submit"
                elevation="1"
            >
              <BaseIcon v-if="tryingToLogIn" name="sync" spin />
              <span v-else>
                {{$t(isReset?'login.reset':'login.access')}}
              </span>
            </v-btn>
          </div>
          <!--          :disabled="tryingToLogIn"-->

          <v-card-text style="color: #64d2ff; cursor: pointer">
            <span @click="switchReset" >{{$t(isReset?'login.goLogin':'login.goReset')}}</span>
          </v-card-text>
        </v-container>
      </v-form>
    </v-card>
  </Layout>
</template>


<style lang="scss" module>
  @import '@design';
  .error {
    color: #64d2ff;
  }

  .card{
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    background-color: $color-bg-navbar !important;
    width: 398px;
    min-height: 590px;
    .title{
      //font-family: Poppins;
      text-align: center;
      font-size: 20px;
      font-weight: 600;
      font-stretch: normal;
      font-style: normal;
      line-height: 1;
      letter-spacing: normal;
      text-align: center;
      color: #ffffff;
      padding-top: 0px;
    }

    .emailAddress{
      width: 300px;
      height: 52px;
    }

    .check{
      //font-family: Poppins;
      font-size: 12px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.83;
      letter-spacing: -0.14px;
      color: #ffffff;
      //background-color: #ffffff ;
    }

    .loginButton{
      width: 300px;
      height: 52px;
      color: #ffffff;
      background-color: #0a84ff !important;
    }
  }

  .container {
    min-width: $size-content-width-min;
    max-width: $size-content-width-max;
    margin: 0 auto;
    display: flex;
    min-height: 600px;
    padding-top: 80px;
    padding-bottom: 30px;
    .content {
      width: 90%;
      padding: 49px;
      text-align: left;
      background-color: $color-form-bg;
      margin: 0 auto;
      max-width: 400px;
      // max-height: 550px;
      .title {
        font-size: 24px;
        font-weight: 600;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.67;
        letter-spacing: -0.4px;
        margin-bottom: 10px;
      }
      .body {
        font-family: $font-input;
        .loginButton {
          margin-bottom: 5px;
          margin-top: 10px;
          width: 100%;
        }
      }
    }
  }

</style>
